import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {State} from '../types'
import {Api} from '../utils/api'

type Extra = {
  api: Api
  controllerParams: ControllerParams
}

export const createAsyncAction = asyncActionsFactory<State, Extra>()
